/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetPublic } from "../../funcs/imagesGetPublic.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetPublicImageRequest$inboundSchema,
};

export const tool$imagesGetPublic: ToolDefinition<typeof args> = {
  name: "images-get-public",
  description: `Get an image by its public ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesGetPublic(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value?.result;

    return formatResult(value, apiCall);
  },
};
